import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getAllNotifications = (searchText, pageNumber, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_ALL_NOTIFICATIONS(
      searchText,
      pageNumber,
      pageSize
    ),
    "",
    cancelToken
  );
};

export default getAllNotifications;
